import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../components/Layout"; // senin paylaştığın Layout (Header+Sidebar)

const AdminShell: React.FC = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default AdminShell;
